module.exports = __webpack_public_path__ + "static/img/platphom7.7c27aa36.png";